












import { Vue, Component, Mixins } from "vue-property-decorator";

@Component
export default class extends Mixins() {
  latestWorkorder: any[] = [];
  loading: boolean = false;

  async loadLatestWorkorder() {
    this.loading = true;
    const res = await this.$store.dispatch("statistics/latestWorkorder", {});
    if (res && res.Data && res.Data !== "{}") {
      this.latestWorkorder = res.Data;
    }
    this.loading = false;
  }

  mounted() {
    this.loadLatestWorkorder();
  }
}
